import { render } from "./ViewTags.vue?vue&type=template&id=69b8a1f1"
import script from "./ViewTags.vue?vue&type=script&lang=js"
export * from "./ViewTags.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__